function NotFoundPage() {
  return (
    <div
      style={{
        backgroundColor: "#ffe6f0",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        color: "#d63384",
        padding: "2rem",
        textAlign: "center",
        fontFamily: "'Segoe UI', sans-serif",
      }}
    >
      <h1 style={{ fontSize: "80px", margin: 0, fontFamily: "sfpro" }}>404</h1>
      <p style={{ fontSize: "24px", marginTop: "1rem", fontFamily: "sfpro" }}>
        Упс... Мы не нашли такую страницу 💔
      </p>
      <p style={{ fontSize: "18px", color: "#a61e4d", fontFamily: "sfpro" }}>
        Возможно, она была удалена или перемещена.
      </p>
      <a
        href="/"
        style={{
          marginTop: "2rem",
          padding: "12px 24px",
          backgroundColor: "#ff66a3",
          color: "#fff",
          borderRadius: "30px",
          textDecoration: "none",
          fontWeight: "bold",
          transition: "0.3s ease",
          fontFamily: "sfpro",
        }}
      >
        Вернуться на главную
      </a>
    </div>
  );
}

export default NotFoundPage;
